const Pill = ({ text, customClass }) => {
    const color = text === "Completed" ? "34" : "61"
    return (
        <div className={`pill bg${color} br50px px1rem fs12px c1 ${customClass}`} style={{ width: "120px", textAlign: "center" }}>
            {text}
        </div>
    )
}

export default Pill